import { SET_CURRENT_LANGUAGE, SET_PROJECT_LANGUAGES } from "./ActionTypes";

export const setCurrentLanguageAction = (currentLanguage) => ({
  type: SET_CURRENT_LANGUAGE,
  currentLanguage,
});

export const setProjectLanguagesAction = (languages) => ({
  type: SET_PROJECT_LANGUAGES,
  languages,
});

export const setProjectLanguages =
  ({ currentLanguageSlug, languages }) =>
  (dispatch) => {
    const language = languages?.params?.data?.find(
      ({ language }) => language === currentLanguageSlug,
    );

    const languagesBySlugAndId = languages?.params?.data.reduce((acc, curr) => {
      acc[curr.language] = curr;
      acc[curr.uuid] = curr;

      return acc;
    }, {});

    dispatch(setCurrentLanguageAction(language));
    dispatch(setProjectLanguagesAction(languagesBySlugAndId));
  };
